<template>
  <div class="chart">
    <div class="chart-head">
      {{ info.headName }}
    </div>
    <div class="chart-cont">
      <!-- 主Y轴 -->
      <div class="contNum" v-if="info.id === 'chart5'">
        <div>45</div>
        <div>异常总数</div>
        <div>32</div>
        <div>物防总数</div>
        <div>32</div>
        <div>技防总数</div>
      </div>
      <!-- 行内 -->
      <div :id="`${info.id}`" :style="{ width: '100%', height: '100%' }"></div>
    </div>
  </div>
</template>
<script>
import { commonBarCharts, pictorialCharts } from "@/assets/chart-JS/barCharts";
import {
  commonLineCharts,
  doubleLineCharts,
} from "@/assets/chart-JS/lineCharts";
import { commonRadarCharts } from "@/assets/chart-JS/radarCharts";
import { commonGaugeCharts } from "@/assets/chart-JS/gaugeCharts";
import { resizeEchartsByDiv } from "@/assets/utils/resizeEchartsByDiv";
import infoCode from "./infoCode.vue";
export default {
  props: ["chartInfo"],
  components: {
    infoCode,
  },
  data() {
    return {
      info: { headName: "", id: "" },
      chartIdList: [],
      timer: null, // 定时器
      yName: "单位",
      barData1: [],
      barData2: [],
      barData3: [],
      getDataInterval:""
    };
  },
  mounted() {
    // this.getTestBarData();
    // 上级使用for循环 导致这个先执行，所以使用nextTick函数
    this.$nextTick(() => {
      this.info = this.chartInfo;
    });
    // 定时器
    this.timer = setTimeout(() => {
      resizeEchartsByDiv(this.info.id, this.info.id, this.chartIdList);
        this.getDataInterval = setInterval(() => {
        if (this.info.id === "chart1") {
        let ran = (Math.floor(Math.random() * 10) + 1) * 123;
        let ran1 = (Math.floor(Math.random() * 10) + 1) * 123;
        this.barData1.push(ran);
        this.barData2.push(ran1);
        if (this.barData1.length>5||this.barData2.length>5) {
            this.barData1.shift();
            this.barData2.shift();
        }
        this.barChart(this.barData1,this.barData2);
        }
        if (this.info.id === "chart2") {
            let ran = (Math.floor(Math.random() * 10) + 1) * 123;
            let ran1 = (Math.floor(Math.random() * 10) + 1) * 123;
            this.barData1.push(ran);
            this.barData2.push(ran1);
            if (this.barData1.length>5||this.barData2.length>5) {
                this.barData1.shift();
                this.barData2.shift();
            }
            this.doubleLineChart(this.barData1,this.barData2);
        }
        if (this.info.id === "chart3") {
            let data = (Math.floor(Math.random() * 100) + 1);
            this.gaugeChart(data);
        }
        if (this.info.id === "chart4") {
            let data = Math.random()*(0 - 1)+1;
            const num = Number(data.toFixed(1).toString().match(/^\d+(?:\.\d{0,2})?/));
            this.barData3.push(num)
             if (this.barData3.length>5) {
                this.barData3.shift();
            }
            this.radarChart(this.barData3);
        }
        if (this.info.id === "chart5") {
            let ran = (Math.floor(Math.random() * 10) + 1) * 123;
            this.barData1.push(ran);
            if (this.barData1.length>6) {
                this.barData1.shift();
            }
            this.pictorialChart(this.barData1);
        }
        if (this.info.id === "chart6") {
            let ran = (Math.floor(Math.random() * 10) + 1) * 123;
            this.barData1.push(ran);
            if (this.barData1.length>5) {
                this.barData1.shift();
            }
            this.lineChart(this.barData1);
        }
      }, 2000);
    }, 200);
  },
  methods: {
    // 柱形图
    barChart(barData1,barData2) {
      let id = this.chartIdList[this.info.id];
      this.chartIdList[this.info.id].clear;
      let xAxis = ["数据1", "数据2", "数据3", "数据4", "数据5", "数据6"];
      let series = [
        {
          name: "类型一",
          data: [500, 300, 600, 700, 500, 900],
        },
        {
          name: "类型二",
          data: [600, 800, 950, 200, 400, 300],
        },
      ];
      let barChartData = { id, xAxis, series,barData1,barData2 };
      commonBarCharts(barChartData);
    },
    // 象形柱状图
    pictorialChart(barData1) {
      let id = this.chartIdList[this.info.id];
      let xAxis = ["消防烟感", "摄像机", "环境烟感", "路灯", "地磁"];
      let pictorialChartData = { id, xAxis,barData1};
      pictorialCharts(pictorialChartData);
    },
    // 线型图
    lineChart(barData1,barData2) {
      let id = this.chartIdList[this.info.id];
      this.chartIdList[this.info.id].clear;
      let xAxis = ["数据1", "数据2", "数据3", "数据4", "数据5", "数据6"];
      let series = {
        name: "text",
        // data: this.barData1,
        data: [600, 800, 950, 200, 400, 300],
      };
      let lineChartData = { id, xAxis, series,barData1,barData2  };
      commonLineCharts(lineChartData);
    },
    // 双线图
    doubleLineChart(barData1,barData2) {
      let id = this.chartIdList[this.info.id];
      this.chartIdList[this.info.id].clear;
      let xAxis = ["数据1", "数据2", "数据3", "数据4", "数据5", "数据6"];
      let series = [
        {
          name: "text",
          // data: this.barData1,
          data: [6000, 8000, 9500, 2000, 4000, 3000],
        },
        {
          name: "text2",
          // data: this.barData1,
          data: [5000, 3000, 6000, 7000, 5000, 9000],
        },
      ];
      let doublelineChartData = { id, xAxis, series,barData1,barData2};
      doubleLineCharts(doublelineChartData);
    },
    // 雷达图
    radarChart(barData3) {
      let id = this.chartIdList[this.info.id];
      this.chartIdList[this.info.id].clear;
      let series = { name: "数据一", data: barData3 };
      let radarChartData = { id, series };
      commonRadarCharts(radarChartData);
    },
    // 仪表盘
    gaugeChart(data) {
      let id = this.chartIdList[this.info.id];
      this.chartIdList[this.info.id].clear;
      // let num = this.gauge;
      let num = data;
      let series = { name: "数据一", data: [6000, 7000, 6000] };
      let gaugeChartData = { id, num, series ,};
      commonGaugeCharts(gaugeChartData);
    },
  },
  destroyed() {
    //页面销毁前清除定时器
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
    if (this.getDataInterval)clearInterval(this.getDataInterval);
  },
};
</script>
<style lang="less" scoped>
.chart {
  width: 100%;
  height: 100%;
  .chart-head {
    width: 100%;
    height: 35px;
    // background: url("../../assets/images/chart-title.png") no-repeat 0 0;
    background-size: 100% 100%;
    padding-left: 31px;
    padding-top: 19px;
    font-size: 18px;
    font-family: siYuan;
    color: #ffffff;
    line-height: 38px;
    /* 文字不可选取 */
    // user-select: none;
  }
  .chart-cont {
    width: 100%;
    height: calc(100% - 53px);
    // background: url("../../assets/images/chart-bg.png") no-repeat 0 0;
    background-size: 100% 100%;
    position: relative;

    .yName {
      position: absolute;
      top: 6px;
      left: 12px;
      font-size: 12px;
      font-weight: 400;
      color: #ffffff;
    }

    .contNum {
      position: absolute;
      top: 16px;
      left: 20px;
      color: #ffffff;
      display: flex;
      flex-direction: column;
      align-items: center;

      div {
        color: #ffffff;
        font-size: 14px;
        margin-bottom: 2px;
      }

      div:nth-child(1) {
        font-size: 24px;
        font-weight: bold;
        color: #ff2a2a;
      }
      div:nth-child(3) {
        font-size: 24px;
        font-weight: bold;
        color: #2af5f7;
        margin-top: 2px;
      }
      div:nth-child(5) {
        font-size: 24px;
        font-weight: bold;
        color: #2af5f7;
        margin-top: 2px;
      }
    }
  }

  .chart-cont2 {
    width: 100%;
    height: calc(100% - 36px);
    background: url("../../assets/images/chart-bg.png") no-repeat 0 0;
    background-size: 100% 100%;
    padding: 4px 12px 14px;
    overflow: auto;
  }
}
</style>